module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "service-sec container"
  }, [_c('div', {
    staticClass: "sec-text col-sm-12 col-md-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 button-row"
  }, [_c('div', {
    staticClass: "btn-holder"
  }, [_c('router-link', {
    staticClass: "btn-primary text-uppercase active md-round",
    attrs: {
      "tag": "a",
      "to": {
        name: 'Products'
      }
    }
  }, [_vm._v("\n                        Læs mere om vores transportløsninger  "), _c('i', {
    staticClass: "fas fa-chevron-right"
  })])], 1)])])]), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "icon big"
  }, [_c('i', {
    staticClass: "fal fa-shipping-fast fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "txt-holder"
  }, [_c('h3', {
    staticClass: "heading2"
  }, [_vm._v("Dag til dag distribution")]), _vm._v(" "), _c('p', [_vm._v("\n                        Dag til dag distribution til og fra Ærø."), _c('br'), _vm._v("\n                        P. Pedersen & Søn transporterer alt fra småpakker, stykgods, partigods eller full load, køle-/ frysevarer samt farligt gods.\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "icon big"
  }, [_c('i', {
    staticClass: "fal fa-thumbs-up fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "txt-holder"
  }, [_c('h3', {
    staticClass: "heading2"
  }, [_vm._v("Anerkendte transportører")]), _vm._v(" "), _c('p', [_vm._v("\n                        Gennem samarbejde med anerkendte transportører, kan vi betjene hele landet.\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "icon big"
  }, [_c('i', {
    staticClass: "fal fa-arrows fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "txt-holder"
  }, [_c('h3', {
    staticClass: "heading2"
  }, [_vm._v("Fleksible transportløsninger")]), _vm._v(" "), _c('p', [_vm._v("\n                        Fleksible transportløsninger med høj leveringssikkerhed og effektiv håndtering til fornuftige priser. Vi finder altid en løsning der passer dig.\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "icon big"
  }, [_c('i', {
    staticClass: "fal fa-handshake fa-fw"
  })]), _vm._v(" "), _c('div', {
    staticClass: "txt-holder last"
  }, [_c('h3', {
    staticClass: "heading2"
  }, [_vm._v("Siden 1921")]), _vm._v(" "), _c('p', [_vm._v("\n                        P. Pedersen & Søn Fragt og Vognmandsfirma startede i 1921 og køres i dag af tredje generation"), _vm._v(".\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sec-logo col-sm-12 col-md-6"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/images/pp_logo.png"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "40%",
      "margin": "0 auto",
      "display": "block"
    },
    attrs: {
      "src": "/static/images/100_aar.png"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cc1dd32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/index-boxes.vue
// module id = 271
// module chunks = 1